export default [
    {
        path: '/imports',
        name: 'imports',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Importações',
            icon: 'mdi-marker-check',
            breadcrumbs: [
                { text: 'Importações', disabled: true }
            ]
        }
    }
]